import type { FaireProductEntity } from "../../entity_types/product";

export const p_89ta7gu8gr: FaireProductEntity = {
  token: "p_89ta7gu8gr",
  type: "product",
  name: "Sunday Reset Duo",
  brandToken: "b_4240zqg5kc",
  brandName: "Ceremonia",
  imageUrl:
    "https://cdn.faire.com/fastly/f6f066b8f49d7a04e4df4315c1f6f5f1c092c19ab769e5ee977af725c3f8a041.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 31,
  description: "Sunday Reset Duo for wholesale.",
  tags: ["haircare", "skincare"],
  caseSize: 2,
  msrpDollars: 62,
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-04-14T00:00:00.000Z",
    importedBy: "ceremonia-brand-prototype",
  },
  categoryTokens: [],
};
